import axios from "axios";
import { requestError } from "../utility/requestError";

const configJson = require("../config.json");
const APIBASE = new URL(configJson.apiBase);
const APIURL = APIBASE + "api/search/elabour/query";
const CONTEXTURL = APIBASE + "api/search/elabour-contexts/query";

/**
 * Request to get the content of a basket.
 *
 * @param basketId The id of the basket.
 * @param sessionExpiredDispatcher Callback function to be called on a 401 error.
 * @param loginStateDispatcher Callback function to be called on a 401 error.
 * @returns {function(): *}
 */
export default function basketContentSearchRequest(
  basketId,
  sessionExpiredDispatcher,
  loginStateDispatcher
) {
  return async () => {
    let content;
    await axios
      .post(
        APIURL,
        {
          pageSize: 10,
          offset: 0,
          overview: true,
          term: "",
          filters: {
            baskets: [basketId]
          }
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("Bearer")
          }
        }
      )
      .then(function(response) {
        content = response.data;
      })
      .catch(requestError(sessionExpiredDispatcher, loginStateDispatcher));

    await axios
      .post(
        CONTEXTURL,
        {
          pageSize: 10,
          offset: 0,
          overview: true,
          term: "",
          filters: {
            baskets: [basketId]
          }
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("Bearer")
          }
        }
      )
      .then(function(response) {
        content.hits.hits.push(...response.data.hits.hits);
        content.aggregations.significantTerms.buckets.push(
          response.data.aggregations.significantTerms.buckets
        );
      })
      .catch(requestError(sessionExpiredDispatcher, loginStateDispatcher));

    return content;
  };
}
